module.exports = __webpack_public_path__ + "img/set-complet-cracker-banana.f43a7dd7.jpg";